module.exports = __webpack_public_path__ + "img/elegant-artichoke-pockets.104c7edd.jpg";